export const pilotDevices = [
  {
    id: "demo-bar-back",
    device_code: "TLS-MFX-001",
    name: "Bar Back Fridge",
    location_name: "Marathon Futurex",
    equipment_type: "fridge",
    current_temperature_c: 3.2,
    maximum_temperature_c: 5,
    status: "online",
    connection_path: "direct_wifi",
    last_seen_at: new Date(Date.now() - 21_000).toISOString(),
    pending_records: 0,
    wifi_rssi: -58,
    firmware_version: "0.1.0",
    readings: [3.1, 3.3, 3.2, 3.4, 3.5, 3.3, 3.1, 3.2, 3.4, 3.2, 3.1, 3.2],
  },
  {
    id: "demo-display",
    device_code: "TLS-MFX-002",
    name: "Display Fridge",
    location_name: "Marathon Futurex",
    equipment_type: "fridge",
    current_temperature_c: 4.6,
    maximum_temperature_c: 5,
    status: "online",
    connection_path: "direct_wifi",
    last_seen_at: new Date(Date.now() - 38_000).toISOString(),
    pending_records: 0,
    wifi_rssi: -64,
    firmware_version: "0.1.0",
    readings: [3.8, 3.9, 4.1, 4.2, 4.4, 4.3, 4.5, 4.4, 4.6, 4.7, 4.5, 4.6],
  },
  {
    id: "demo-pizza",
    device_code: "TLS-MFX-003",
    name: "Pizza Makeline Fridge",
    location_name: "Marathon Futurex",
    equipment_type: "fridge",
    current_temperature_c: 6.4,
    maximum_temperature_c: 5,
    status: "alert",
    connection_path: "esp_now_relay",
    last_seen_at: new Date(Date.now() - 34_000).toISOString(),
    pending_records: 3,
    wifi_rssi: -83,
    firmware_version: "0.1.0",
    readings: [3.9, 4.1, 4.2, 4.5, 4.8, 5.1, 5.4, 5.8, 6.0, 6.2, 6.3, 6.4],
  },
  {
    id: "demo-chinese",
    device_code: "TLS-MFX-004",
    name: "Chinese Makeline Fridge",
    location_name: "Marathon Futurex",
    equipment_type: "fridge",
    current_temperature_c: 3.8,
    maximum_temperature_c: 5,
    status: "online",
    connection_path: "direct_wifi",
    last_seen_at: new Date(Date.now() - 16_000).toISOString(),
    pending_records: 0,
    wifi_rssi: -61,
    firmware_version: "0.1.0",
    readings: [4.0, 3.9, 3.8, 3.7, 3.8, 3.9, 3.8, 3.7, 3.9, 3.8, 3.7, 3.8],
  },
  {
    id: "demo-chest",
    device_code: "TLS-MFX-005",
    name: "Chest Freezer",
    location_name: "Marathon Futurex",
    equipment_type: "freezer",
    current_temperature_c: -20.4,
    maximum_temperature_c: -18,
    status: "online",
    connection_path: "direct_wifi",
    last_seen_at: new Date(Date.now() - 12_000).toISOString(),
    pending_records: 0,
    wifi_rssi: -55,
    firmware_version: "0.1.0",
    readings: [-20.1, -20.4, -20.2, -20.6, -20.8, -20.5, -20.4, -20.7, -20.5, -20.3, -20.6, -20.4],
  },
  {
    id: "demo-visi",
    device_code: "TLS-MFX-006",
    name: "Visi Freezer",
    location_name: "Marathon Futurex",
    equipment_type: "freezer",
    current_temperature_c: -18.9,
    maximum_temperature_c: -18,
    status: "offline",
    connection_path: "local_storage",
    last_seen_at: new Date(Date.now() - 18 * 60_000).toISOString(),
    pending_records: 2,
    wifi_rssi: -91,
    firmware_version: "0.1.0",
    readings: [-19.5, -19.3, -19.2, -19.0, -18.9, -18.8, -18.7, -18.9, -18.8, -18.9, -18.9, -18.9],
  },
].map((device) => ({
  organization_id: "demo-org",
  location_id: "demo-location",
  connectivity_type: "wifi",
  provisioning_status: "active",
  minimum_temperature_c: null,
  alert_delay_minutes: 10,
  measurement_interval_seconds: 60,
  logging_interval_seconds: 600,
  heartbeat_interval_seconds: 60,
  wifi_ssid: "IOT",
  hardware_name: "ESP32-WROOM-32D",
  firmware_target_version: null,
  firmware_update_status: "idle",
  firmware_update_requested_at: null,
  firmware_update_started_at: null,
  firmware_update_completed_at: null,
  firmware_update_error: null,
  wifi_channel: 6,
  station_mac: "30:76:F5:E5:87:1C",
  sensor_status: "ok",
  relay_enabled: true,
  relay_peer_count: 4,
  settings_revision: 2,
  settings_applied_revision: 2,
  settings_applied_at: new Date(Date.now() - 45_000).toISOString(),
  read_request_id: null,
  read_requested_at: null,
  read_completed_at: null,
  ...device,
}));

export const pilotAlerts = [
  {
    id: "demo-alert-1",
    device_id: "demo-pizza",
    device_name: "Pizza Makeline Fridge",
    severity: "critical",
    kind: "temperature_high",
    title: "Pizza Makeline is above 5 C",
    detail: "6.4 C measured. The high-temperature condition has continued for 12 minutes.",
    status: "open",
    opened_at: new Date(Date.now() - 12 * 60_000).toISOString(),
  },
  {
    id: "demo-alert-2",
    device_id: "demo-visi",
    device_name: "Visi Freezer",
    severity: "warning",
    kind: "device_offline",
    title: "Visi Freezer has stopped reporting",
    detail: "Last heartbeat was 18 minutes ago. Two records are safe in local storage.",
    status: "open",
    opened_at: new Date(Date.now() - 18 * 60_000).toISOString(),
  },
];

export const pilotProfile = {
  display_name: "Mikyle",
  email: "mikyletalpade@gmail.com",
  role: "super_admin",
  organization_name: "M Square LLP",
  location_name: "Marathon Futurex",
};

export const pilotLocations = [
  { id: "demo-location", organization_id: "demo-org", name: "Marathon Futurex", address: "Lower Parel, Mumbai" },
];
